import { Shadow, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { TradingList } from '../TradingListTable';

import { CardItem } from './CardItem';

import { PlatformCardProps } from '.';

export const ContentTablet: React.FC<PlatformCardProps> = ({
  platformName,
  balance,
  allocatedLimit,
  acceptableLoss,
  resultDay,
  tradings,
}) => {
  return (
    <Shadow
      borderRadius="md"
      marginBottom={Spacing['inset.sm']}
      paddingX={Spacing['inline.xxxs']}
      level={1}>
      <HStack
        px={Spacing['inline.xxxs']}
        py={Spacing['inset.sm']}
        justifyContent="space-between"
        width="100%">
        <CardItem label="Plataforma" value={platformName} />
        <CardItem label="Saldo disponível" value={balance} />
        <CardItem label="Limite alocado" value={allocatedLimit} />
        <CardItem label="Prejuízo aceitável" value={acceptableLoss} />
        <CardItem label="Resultado do dia " value={resultDay} />
      </HStack>
      <Box paddingX={Spacing['inline.xxxs']}>
        <TradingList tradingList={tradings} />
      </Box>
    </Shadow>
  );
};
